import { MaterialIcon } from '@gorila-shared-ui/components';
import { memo, useMemo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useStyles } from '../../../hooks/useStyles';
import { GptEventTimeLine } from '../../../types/gpt';
import { useMapActions } from '../hooks/useMapActions';

type Props = {
  engineOffEvents: GptEventTimeLine;
};

function GptEventEngineOffMarker({ engineOffEvents }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const { zoomTo } = useMapActions();
  const iconWrapper = css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 0,
    height: '25px',
    width: '25px',
    borderRadius: '50%',
    background: theme.colors.red200,
    boxSizing: 'border-box',
  });
  const icon = useMemo(
    () => (
      <span className={iconWrapper}>
        <MaterialIcon name="power_settings_new" size="16px" />
      </span>
    ),
    [iconWrapper],
  );

  if (!engineOffEvents) return null;

  const [lng, lat] = engineOffEvents.startPoint.coordinates;

  const onClick = () => {
    zoomTo({
      lng: lng,
      lat: lat,
    });
  };

  return (
    <Marker longitude={lng} latitude={lat} onClick={onClick}>
      {icon}
    </Marker>
  );
}

export default memo(GptEventEngineOffMarker);
